export default {"src":"/_next/static/media/upload.ecce1575.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};